export class SetFilterDisplayValue {
}
SetFilterDisplayValue.SELECT_ALL = '__AG_SELECT_ALL__';
SetFilterDisplayValue.ADD_SELECTION_TO_FILTER = '__AG_ADD_SELECTION_TO_FILTER__';
